import getBannersForEntities from './get-banners-for-entities';

export default getBannersForEntities;
